import React from "react";

function sanitizeFilename(name) {
  return (
    String(name || "profile")
      // eslint-disable-next-line no-control-regex
      .replace(/[<>:"/\\|?*\x00-\x1f]/g, "_")
      .trim() || "profile"
  );
}

/*
 * Generates a professional vector PDF from profile data
 */
export const downloadProfile = async (profileData) => {
  const [{ pdf }, { ProfilePdfDocument }] = await Promise.all([
    import("@react-pdf/renderer"),
    import("./ProfilePdfDocument"),
  ]);

  const doc = React.createElement(ProfilePdfDocument, { data: profileData });
  const blob = await pdf(doc).toBlob();

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${sanitizeFilename(profileData?.name)}_profile.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
